import { i18n } from 'fishx';
import { message } from '@whalecloud/fdx';

// 【offerGroupType】类型（OfferGroupType=3，依赖产品|OfferGroupType=4，个性化资费|OfferGroupType=5，实物产品），
// 【GroupType】选择方式（A全选|B单选|C多选），
// 【UpperLimit】和【LowerLimit】数量上下限，
// 【Seq】顺序。三个参数共同决定如何渲染。
// 【offerGroupMemDtoList[0].duplicateFlag】非 A 或者 非空，才可以重复订购
export const OfferGroupTypeOpt = {
  DEPENDENT_PLAN: 3, // 依赖产品
  INDIVIDUAL_PLAN: 4, // 个性化资费
  GOODS: 5, // 实物offer
};

export const OfferGroupTypeList = [
  {
    value: OfferGroupTypeOpt.DEPENDENT_PLAN,
    // text: 'Dependent Plan(依赖产品)',
    text: i18n('DEPENDENT_PLAN'),
  },
  {
    value: OfferGroupTypeOpt.INDIVIDUAL_PLAN,
    // text: 'Individual Plan(个性化资费)',
    text: i18n('INDIVIDUAL_PLAN'),
  },
  {
    value: OfferGroupTypeOpt.GOODS,
    // text: 'Goods(实物offer)',
    text: i18n('GOODS'),
  },
];

export const needCollectionType = ['3', '4', '5'];

export const isRequired = value => `${value}` === '1';

export const getDefaultTree = offerGroupAttr => {
  // 是否渲染，看mem里的成员是否必选
  const result = offerGroupAttr.map(group => {
    const children = [];
    const { offerGroupMemDtoList } = group;
    (offerGroupMemDtoList || []).forEach((mem = {}) => {
      const isNecessary = isRequired(mem.necessary);
      if (isNecessary) {
        children.push({
          ...mem,
          isNecessary: true,
        });
      }
    });
    return {
      ...group,
      children,
    };
  });
  return result;
};

export const getNewOfferTree = (selectedInfo, offerGroupArr) => {
  const addOfferInfo = [];
  let isExceeded = false;
  Object.keys(selectedInfo).some(code => {
    const offerList = selectedInfo[code];
    const offerGroup = (offerGroupArr || []).find(group => group.offerGroupCode === code) || {};
    const { upperLimit } = offerGroup;
    if (offerGroup) {
      if (upperLimit && offerList.length > upperLimit) {
        isExceeded = true;
      } else {
        const result = {
          ...offerGroup,
          children: offerList,
        };
        addOfferInfo.push(result);
      }
    }
    return isExceeded;
  });
  return {
    isExceeded,
    addOfferInfo,
  };
};

export const checkGroupLowLimit = (tree, nameKey) => new Promise((resolve) => {
  const result = tree.some(it => {
    const { children, lowLimit } = it;
    if (!lowLimit) {
      return false;
    }
    return children.length < lowLimit;
  });
  if (result) {
    // 选中的offer数量不满足lowlimit条件
    message.error(i18n('LOW_LIMIT_WARING', { name: i18n(nameKey) }));
  } else {
    resolve(tree);
  }
});
